import { render, staticRenderFns } from "./InitDossierProgress.vue?vue&type=template&id=56d059b0&scoped=true"
import script from "./InitDossierProgress.vue?vue&type=script&lang=ts"
export * from "./InitDossierProgress.vue?vue&type=script&lang=ts"
import style0 from "./InitDossierProgress.vue?vue&type=style&index=0&id=56d059b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d059b0",
  null
  
)

export default component.exports